import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Ellipse4 from '../../assets/Ellipse4.svg'
import { formValidator } from '../../helpers'
import DecoContainer from '../../Layout/DecoContainer'
import Container from './styles'
import StageOne from './StageOne'
import { useDispatch } from 'react-redux'
import StageTwo from './StageTwo'
import Alerts from '../Alert';
import StageThree from './StageThree'
import { usePaystackPayment } from 'react-paystack';
import {creatOrder,updateOrder} from '../../store/actions';
import calculate from 'calculate-geo-distance'
import { useSelector } from 'react-redux'

const Auth = () => {
 
  const [address, setAddress] = React.useState("");
  const { userData } = useSelector((s) => s.UserData)
  const dispatch = useDispatch();
  const [address2, setAddress2] = React.useState("");
  const [clickedAddress, setClickedAddress] = React.useState({});
  const [distance, setDistance] = React.useState({})
  const [distance2, setDistance2] = React.useState({})
  const [datas, setData] = React.useState([])
  const [OrderAlert, setOrderAlert] = React.useState({value:false, result:false});
  const [reference, setReference] = useState("")
  const fi = Math.round(datas.amount)*100;
  const config = {
    reference: (new Date()).getTime().toString(),
    email: "user@example.com",
    amount: fi,
    publicKey: 'pk_test_a80e0012d018d05da71e899cf400effd0139463b',
};
const onSuccess = (reference) => {
  
  dispatch(updateOrder({
    is_successful: true,
    transaction_reference: reference.reference,
    id: datas.id
}))

setOrderAlert({value:true, result:true})
};
const onClose = () => {
  setOrderAlert({value:true, result:false})
}

function Place(words) {
  let n = words.replace(" ", "Nigeria");
  n = n.split(" ");
  return n[n.length - 1];


}
  const { stage } = useParams()
  const storedState = sessionStorage.getItem('authState')
  const [loading, setLoading] = useState(false)
  const appendAddress = {pick_up_address: address, drop_off_address: address2,  pick_up_city: Place(address),
  drop_off_city: Place(address2),  distance:calculate(distance.lat, distance.lng, distance2.lat, distance2.lng)}
  const [formData, setFormState] = useState(() =>
    storedState ? JSON.parse(storedState) : {},
  )
  const navigate = useNavigate()

  const handleInput = ({ target }) => {
    setFormState((s) => ({
      ...s,
      [target.name]: target.value,
    }))
  }

  const handleSubmit = async () => {
    
    if (
      formValidator(document.forms['order--form'].getElementsByTagName('input') )
    ) {
      try {
        setLoading(true)
           if(stage === 'step-1'){
            navigate('/delievery-request/step-2')
           }else if(stage === 'step-2'){ 
             setLoading(true)
             if(userData.email){
             const result = {...formData,...appendAddress, email:userData.email, user_id:userData.id }
             dispatch(creatOrder(result, navigate, setData, setReference))   
            }else {
            const result = {...formData,...appendAddress}
            dispatch(creatOrder(result, navigate, setData))   
           }
             setLoading(false)
           }else if (stage === "step-3"){
           initializePayment(onSuccess, onClose)
          }  
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    }
  }

let initializePayment = usePaystackPayment(config);
console.log(datas, "data")
  return (
    <div>
     {OrderAlert.value ?<Alerts state={datas.reference} amount={datas.amount} setOrderAlert={setOrderAlert} />:
        <DecoContainer
        header={
          <header>
            <div className="ellipse--container">
              <img src={Ellipse4} alt="Ellipse" />
              <h2>
                {stage === 'step-1'
                  ? 'Create your delivery request'
                  : stage == 'step-2'
                  ? 'More details'
                  : 'Proceed to Payment'}
              </h2>
            </div>
            <p>
              {stage === 'step-1'
                ? 'Fill the form below to make a  request'
                : stage == 'step-2'
                ? 'You are almost done!!!!'
                : 'Final stage'}
            </p>
          </header>
        }
        content={
          <div>
          <Container>
            <form name="order--form" onSubmit={(e)=>{
              e.preventDefault()
              handleSubmit()
              }} >
              {stage === 'step-1' && <StageOne {...{ formData, handleInput, loading, address, setAddress,setDistance, setDistance2, address2, setAddress2}} />}
              {stage === 'step-2' && <StageTwo {...{ formData, handleInput, loading, address, address2 }} />}
              {stage === 'step-3' && <StageThree {...{ formData, handleInput, loading, address, address2, datas }} />}
            </form>
          </Container>
          </div>
        }
      />
}
    </div>
  )
}

export default Auth
